import injectSheet from 'react-jss'
import TourOperatorSelector from './TourOperatorSelector'
import styles from './TourOperatorSelector.styles'

export default injectSheet(styles)(TourOperatorSelector)
